__turbopack_context__.v({
  "communicationContactColumn": "FooterLinks-module__geN03q__communicationContactColumn",
  "item": "FooterLinks-module__geN03q__item",
  "wrapper": "FooterLinks-module__geN03q__wrapper",
});
